"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.init = init;
exports.updateIds = updateIds;
exports.routeId = void 0;

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));

var _netUtils = require("@blue/net-utils");

var _constants = require("../utils/constants");

var _utils = require("../utils");

var _stateChange = require("./state-change");

var routeId = (0, _utils.generateUUID)();
exports.routeId = routeId;
var companyId;
var userId;
var sessionId;
var deregister;
(0, _stateChange.subscribe)(function () {
  exports.routeId = routeId = (0, _utils.generateUUID)();
});

function init(_companyId, _userId, _sessionId) {
  var _context;

  var domainAllowList = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  companyId = _companyId;
  userId = _userId;
  sessionId = _sessionId;

  if (deregister) {
    deregister();
  }

  deregister = (0, _netUtils.injectHeaders)({
    'x-company-id': function xCompanyId() {
      return companyId;
    },
    'x-user-id': function xUserId() {
      return userId;
    },
    'x-cobalt-security-userguid': function xCobaltSecurityUserguid() {
      return userId;
    },
    'x-cobalt-security-sessionid': function xCobaltSecuritySessionid() {
      return sessionId;
    },
    'x-session-id': function xSessionId() {
      return sessionId;
    },
    'x-route-id': function xRouteId() {
      return routeId;
    },
    'x-cobalt-pcid': function xCobaltPcid() {
      return routeId;
    },
    'x-chain-id': function xChainId() {
      return (0, _utils.generateUUID)();
    },
    'x-call-id': function xCallId() {
      return (0, _utils.generateUUID)();
    }
  }, (0, _concat.default)(_context = [_constants.currentDomainRegex, _constants.interceptorAllowedDomains]).call(_context, (0, _toConsumableArray2.default)(domainAllowList)));
  return function () {
    if (deregister) {
      deregister();
      deregister = null;
    }
  };
}

function updateIds(_companyId, _userId, _sessionId) {
  companyId = _companyId;
  userId = _userId;
  sessionId = _sessionId;
}
